<template>
  <div class="grid-default !gap-3">
    <Image
      v-if="data.leftImage"
      loading="lazy"
      class="col-span-6 h-full max-h-[174px] rounded-3xl object-cover sm:col-span-2 lg:col-span-4 lg:max-h-[270px]"
      :src="
        data.leftImage.responsiveImage ? data.leftImage.responsiveImage?.src : data.leftImage.url
      "
      :srcset="
        data.leftImage.responsiveImage ? data.leftImage.responsiveImage?.webpSrcSet : undefined
      "
      :width="data.leftImage.width"
      :height="
        data.leftImage.responsiveImage
          ? data.leftImage.responsiveImage?.height
          : data.leftImage.height
      "
      :alt="data.leftImage.alt"
    />
    <Image
      v-if="data.rightImage"
      loading="lazy"
      class="col-span-6 h-full max-h-[174px] rounded-3xl object-cover sm:col-span-4 lg:col-span-8 lg:max-h-[270px]"
      :src="
        data.rightImage.responsiveImage ? data.rightImage.responsiveImage?.src : data.rightImage.url
      "
      :srcset="
        data.rightImage.responsiveImage ? data.rightImage.responsiveImage?.webpSrcSet : undefined
      "
      :width="data.rightImage.width"
      :height="
        data.rightImage.responsiveImage
          ? data.rightImage.responsiveImage?.height
          : data.rightImage.height
      "
      :alt="data.rightImage.alt"
    />
  </div>
</template>

<script setup lang="ts">
import type { MultipleImageRecord } from '~/types/generated'

defineProps({
  data: {
    type: Object as PropType<MultipleImageRecord>,
    default: () => {}
  }
})
</script>
